jQuery(document).ready(function ($) {
    // Toggle mobile menu
    $('#side-menu-trigger').click(function () {
        $('#side-menu').toggleClass('shown');
        jQuery('body').toggleClass('modal-open');

        jQuery('body').prepend('<div class="modal-backdrop fade show"></div>');
    });
    // Toggle mobile menu
    $('#side-menu-closer').click(function () {
        $('#side-menu').toggleClass('shown');
        jQuery('body').toggleClass('modal-open');

        jQuery('.modal-backdrop').remove();
    });

    $('.large-tabs-clickers li button').on('click', function () {
        var tab = $(this).parent().index();
        $('.large-tabs li button').removeClass('active');
        $(this).addClass('active');
        $('.large-tabs-content > div').removeClass('active');
        $('.large-tabs-content > div').eq(tab).addClass('active');
    });

    $('.invest-tabs li a').on('click', function (e) {
        e.preventDefault();
        var tab = $(this).parent().index();
        $('.invest-tabs li a').removeClass('active');
        $(this).addClass('active');
        $('.invest-tabs-content > div').addClass('hidden');
        $('.invest-tabs-content > div').eq(tab).removeClass('hidden');

        if (window.pageYOffset > $('.invest-tabs-content').offset().top) {
            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $('.invest-tabs-content').offset().top - 150
                }, 500);
            }, 100);
        }
        const currentParam = getUrlParameter('tab') ? getUrlParameter('tab') : 'pitch';
        const newParam = $(this).attr('href').replace('#', '');

        // Find all login-buttons and and invest-button and update the href
        $('.login-button, .invest-button, .register-button').each(function () {
            $(this).attr('href', $(this).attr('href').replace('tab=' + currentParam, 'tab=' + newParam));
        });

        // Add the id to the tab param in the URL
        insertParam('tab', newParam);

    });

    $('.imm-stats h5, .main-header h5').on('click', function (e) {
        e.preventDefault();
        if ($(window).outerWidth() <= 768) {

            if (!$(this).hasClass('active')) {

                // Find any other open tabs and close them
                $('.imm-page h5.active').removeClass('active').next().slideUp();
            }

            $(this).next().slideToggle();
            jQuery(this).toggleClass('active');
        }
    });

    if ($('.user-stories-list').length > 0) {
        const startStoriesCarousel = () => {
            var index = $('.user-stories-carousel .active').index();

            var activeImage = $('.user-stories-images > div').eq(index);
            var nextImage = activeImage.next();

            var activeTab = $('.user-stories-carousel > div').eq(index);
            var nextTab = activeTab.next();

            if (nextTab.length == 0) {
                nextTab = $('.user-stories-carousel div').first();
            }
            if (nextImage.length == 0) {
                nextImage = $('.user-stories-images div').first();
            }
            activeImage.removeClass('active');
            activeTab.removeClass('active');
            nextImage.addClass('active');
            nextTab.addClass('active');
        }
        var userStoriesInterval = setInterval(function () {
            startStoriesCarousel();
        }, 5000);

        // Add the click to change the story event
        $('.user-stories-carousel > div').on('click', function () {
            clearInterval(userStoriesInterval);
            $('.user-stories-carousel > div').removeClass('active');
            $(this).addClass('active');

            var index = $(this).index();
            $('.user-stories-images > div').removeClass('active');
            $('.user-stories-images > div').eq(index).addClass('active');

            userStoriesInterval = setInterval(function () {
                startStoriesCarousel();
            }, 3000);
        })
    }

    if ($('.press-articles').length > 0) {
        $('.press-articles').slick(
            {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                dots: true,
                arrows: false,

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            }
        )
    }
    if ($('.istorii-container-carousel').length > 0) {
        $('.istorii-container-carousel').slick(
            {
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 2000,
                dots: true,
                gap: 60,
                arrows: false,
            }
        )
    }

    if ($('.loan-grid .grid').length > 0) {
        $('.loan-grid .grid').slick(
            {
                infinite: true,
                arrows: false,
                dots: true,
                mobileFirst: true,
                autoplay: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: "unslick"
                    }
                ]
            }
        )
    }

    if ($('.blog-grid').length > 0 && jQuery(window).outerWidth() < 768) {
        $('.blog-grid').slick(
            {
                infinite: true,
                arrows: false,
                dots: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                autoplay: true,
            }
        )
    }

    function arrangeHeaderAnimation() {

        // Skip for small screens
        if (jQuery(window).outerWidth() < 768) return false;

        let headerImage = jQuery('#home-animation');
        let header = jQuery('#masthead');
        let headerTopRow = jQuery('#masthead .top-row');

        // Make sure the image is always below the top-row and the bottom of the header
        let headerHeight = header.outerHeight();
        let headerTopRowHeight = headerTopRow.outerHeight();
        let headerImageHeight = headerImage.outerHeight();

        let maxImageHeight = headerHeight - headerTopRowHeight + 80;

        if (headerHeight < headerImageHeight) {
            // Resize the header image to fit the header
            headerImage.css({
                'height': maxImageHeight + 'px',
                'width': 'auto'
            });
        } else {
            headerImage.css({
                'height': maxImageHeight + 'px',
                'width': 'auto'
            });
        }
    }

    jQuery('.menu-trigger').on('click', function () {
        $('#mobile-menu').toggleClass('shown');
        jQuery('body').toggleClass('modal-open');
        jQuery('body').prepend('<div class="modal-backdrop fade show"></div>');
    })
    jQuery(document).on('click', '#mobile-menu-closer', function () {
        $('#mobile-menu').toggleClass('shown');
        jQuery('body').toggleClass('modal-open');

        jQuery('.modal-backdrop').remove();
    })
    jQuery(document).on('click', '.modal-backdrop', function () {
        $('#mobile-menu').toggleClass('shown');
        $('#side-menu').toggleClass('shown');
        jQuery('body').toggleClass('modal-open');

        jQuery('.modal-backdrop').remove();
    })
    jQuery('.menu-item-has-children > a').on('click', function () {
        $(this).parent().toggleClass('active');
    })
    jQuery(document).on('click', '.mobile-menu-back', function () {
        $(this).parents('.menu-item-has-children').removeClass('active');
    })
    jQuery(document).ready(function () {

        if (jQuery('#mobile-menu .sub-menu').length > 0) {

            jQuery('#mobile-menu').prepend(`<li>
            <h4>Meniu Fagura</h4>
            <button class="non-button" id="mobile-menu-closer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 10.7273L17.7273 5L19 6.27273L13.2727 12L19 17.7273L17.7273 19L12 13.2727L6.27273 19L5 17.7273L10.7273 12L5 6.27274L6.27273 5.00001L12 10.7273Z" fill="currentColor"></path>
                </svg>
            </button>
        </li>`);

            jQuery('#mobile-menu-inner').append(`<li class="not-bordered">
            <a class="button primary w-full" href="https://app.fagura.com/login/">Login</a>
        </li><li class="not-bordered">
        <a class="button primary-outline w-full" href="https://app.fagura.com/register/">Creează un cont</a>
    </li>`);

            $('#mobile-menu .sub-menu').each(function () {
                let title = $(this).parent().children('a').text();
                jQuery(this).prepend(`<li>
                <button class="non-button mobile-menu-back">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <line x1="5" y1="12" x2="11" y2="18"></line>
                        <line x1="5" y1="12" x2="11" y2="6"></line>
                    </svg>
                </button>
                <h5>${title}</h5>
            </li>`);
            })
        }
    });

    // On scroll and top offset is > 250px add class to .top-row sticky
    jQuery(window).on('resize load', function () {
        arrangeHeaderAnimation();
    });
    jQuery(window).on('scroll load', function () {
        if (jQuery(window).scrollTop() > 20) {
            jQuery('.top-row').addClass('sticky');
        } else {
            jQuery('.top-row').removeClass('sticky');
        }

        $('.tooltip').remove();

        if ($('.invest-tabs').length) {
            // If it goes past the .invest-tabs add the sticky class
            // if (jQuery(window).scrollTop() > $('.invest-tabs').offset().top && $('.invest-tabs').hasClass('sticky') == false) {
            //     jQuery('.invest-tabs').before('<div class="invest-tabs-placeholder" style="height:' + $('.invest-tabs').outerHeight() + '"></div>');
            //     jQuery('.invest-tabs').addClass('sticky');
            // } else if ($('.invest-tabs-placeholder').length > 0 && jQuery(window).scrollTop() < $('.invest-tabs-placeholder').offset().top) {
            //     jQuery('.invest-tabs-placeholder').remove();
            //     jQuery('.invest-tabs').removeClass('sticky');
            // }

            let margin = jQuery(window).outerWidth() > 768 ? 40 : 24;

            let sticky = $('.imm-stats').offset().top + $('.imm-stats').outerHeight() - margin;
            let header = $('.invest-tabs');

            if (window.pageYOffset > sticky && !jQuery(header).hasClass('sticky')) {
                jQuery(header).addClass("sticky");
                jQuery('.invest-tabs').before('<div class="invest-tabs-placeholder" style="height:' + ($('.invest-tabs').outerHeight() + margin) + 'px"></div>');
            } else if (window.pageYOffset < sticky && jQuery(header).hasClass('sticky')) {
                jQuery('.invest-tabs-placeholder').remove();
                jQuery(header).removeClass("sticky");
            }
        }
    });

    jQuery('.personal-loan-calculator .calculator-field .half-fields button').on('click', function () {
        jQuery(this).parents('.calculator-field').find('button.secondary').removeClass('secondary').addClass('white');
        jQuery(this).addClass('secondary').removeClass('white');

        // Get the value of the button
        var value = jQuery(this).attr('data-val');
        jQuery('#history-type').val(value);
        historyType = value || 'excelent';

        // Calculate the loan
        calcPersonalLoan();
    })
    jQuery('#loan-reason').on('change', function () {
        // Calculate the loan
        calcPersonalLoan();
    });

    // Create a tooltip component for any element with the attribute data-tooltip and data-tooltip-text
    jQuery('[data-tooltip]').on('mouseenter click', function () {
        var tooltipText = jQuery(this).attr('data-tooltip-text');
        jQuery(this).append('<div class="tooltip">' + tooltipText + '</div>');

        // Position the tooltip so it fits in the screen and check the position of the tooltip from the data-tooltip attribute
        var tooltipPosition = jQuery(this).attr('data-tooltip'); // can be top, bottom, left, right
        var tooltip = jQuery(this).find('.tooltip');

        // the tooltip position can be top, bottom, left, right. If it's not set, it will default to bottom
        // If the position is top, show the tooltip on top of the element, if it's bottom, show it on the bottom, etc.
        if (tooltipPosition == 'top') {
            tooltip.css({
                'bottom': jQuery(this).outerHeight() + 10,
                'left': jQuery(this).outerWidth() / 2 - tooltip.outerWidth() / 2
            });
        } else if (tooltipPosition == 'bottom') {
            tooltip.css({
                'top': jQuery(this).outerHeight() + 10,
                'left': jQuery(this).outerWidth() / 2 - tooltip.outerWidth() / 2
            });

        } else if (tooltipPosition == 'left') {
            tooltip.css({
                'top': jQuery(this).outerHeight() / 2 - tooltip.outerHeight() / 2,
                'right': jQuery(this).outerWidth() + 10
            });

        } else if (tooltipPosition == 'right') {
            tooltip.css({
                'top': jQuery(this).outerHeight() / 2 - tooltip.outerHeight() / 2,
                'left': jQuery(this).outerWidth() + 10
            });
        } else {
            tooltip.css({
                'top': jQuery(this).outerHeight() + 10,
                'left': jQuery(this).outerWidth() / 2 - tooltip.outerWidth() / 2
            });
        }

        // If this is a small screen, always align the tooltip to in the center of the screen
        if (jQuery(window).outerWidth() < 768) {
            tooltip.css({
                'top': $(this).offset().top - $(window).scrollTop() + $(this).outerHeight() + 10,
                'left': 20,
                // 'transform': 'translateY(-50%)',
                'position': 'fixed',
                'width': jQuery(window).outerWidth() - 40,
                'maxWidth': jQuery(window).outerWidth() - 40
            });
        }

    }).on('mouseleave', function () {

        // Remove the tooltip when the mouse leaves the element with a 1.5s delay

        const el = jQuery(this).find('.tooltip');
        setTimeout(function () {
            el.remove();
        }, 150);
    });


    jQuery('.has-target-input .selector-option').on('click', function () {
        const el = jQuery(this);

        // Get the target input ID from the data-target attribute
        const targetID = el.parent().attr('data-target');

        // Get the value of the button
        var value = el.attr('data-value');

        // Set the value of the input
        jQuery('#' + targetID).val(value).trigger('change');

        // Remove the selected class from all buttons and add it to the clicked button
        el.siblings('.selector-option').removeClass('selected');
        el.addClass('selected');
    });

    jQuery('.as-nav-for').on('click', function () {
        // Get the select ID from the data-select attribute
        const selectID = jQuery(this).attr('data-select');

        // Get the value of the button
        var value = jQuery(this).attr('data-val');

        // Set the value of the select
        jQuery('#' + selectID).val(value).trigger('change');

        // Remove the 'secondary' class from all buttons and add it to the clicked button
        jQuery(this).siblings('.button').removeClass('secondary').addClass('white');
        jQuery(this).addClass('secondary').removeClass('white');
    });




    jQuery('.switch-loan-calculator-type').on('click', function (e) {
        e.preventDefault();


        const buttonValue = jQuery(this).attr('data-value');

        // Check if buttonValue is either 'personal' or 'business'
        // if (buttonValue !== 'personal' && buttonValue !== 'business') return false;


        calculatorType = buttonValue;

        // console.log({ buttonValue, calculatorType })

        if (buttonValue === 'personal') {
            jQuery('#loan-reason').parent().hide();
            // Update the max value of the loan sum
            jQuery('.calculator-loan-sum-slider').attr('max', 7500);

            if (jQuery('.calculator-loan-sum-slider').val() > 7500) {
                jQuery('.calculator-loan-sum-slider').val(7500);
                jQuery('#calculator-loan-sum').text('€7500');
            }

            jQuery('.field-minmax-labels .max-label').text('€7500');
        } else if (buttonValue === 'business') {
            jQuery('#loan-reason').parent().show();

            const maxValue = jQuery('.calculator-loan-sum-slider').attr('data-max-value');

            jQuery('.calculator-loan-sum-slider').attr('max', maxValue);

            // Set the maximum label
            jQuery('.calculator-loan-sum-slider').closest('.field-minmax-labels .max-label').text('€' + maxValue);
        }

        // jQuery('.business-loan-switcher').toggleClass('hidden');
        // jQuery('.preaprobare-switcher').toggleClass('hidden');

        jQuery(this).removeClass('secondary-outline').addClass('secondary').siblings().removeClass('secondary').addClass('secondary-outline');

        calcPersonalLoan();
        return false;
    });

    if ($('.invest-tabs').length) {
        // Get the current tab
        let currentTab = getUrlParameter('tab');

        if (currentTab.length == 0) {
            currentTab = 'pitch';
        }

        // Show the current tab
        $('.invest-tabs a[href="#' + currentTab + '"').trigger('click');
    }

    document.addEventListener("mousemove", parallax);
    function parallax(event) {
        this.querySelectorAll(".parallax-wrap .parallax-item").forEach((shift) => {
            // If element is in the viewport
            if (shift.getBoundingClientRect().top < window.innerHeight && shift.getBoundingClientRect().bottom > 0) {

                const position = shift.getAttribute("data-value");
                const x = (window.innerWidth - event.pageX * position) / 90;
                const y = (window.innerHeight - event.pageY * position) / 90;

                shift.style.transform = `translateX(${x}px) translateY(${y}px)`;
            }
        });
    }

    function animateFromLeftToRight() {
        const animationContainer = jQuery('.how-it-works-animation');

        // If there is no animation container, return false
        if (!animationContainer.length) return false;

        // First - add the animated class
        animationContainer.addClass('left-arrows-animated right-arrows-animated');

        // After 5 seconds, remove the shown classes
        setTimeout(function () {
            animationContainer.removeClass('left-arrows-shown right-arrows-shown');

            // After .5s remove the animated classes
            setTimeout(function () {
                animationContainer.removeClass('left-arrows-animated right-arrows-animated');

                // Add the reverse animation classes

                animationContainer.addClass('left-arrows-animated-reverse right-arrows-animated-reverse');
                animationContainer.removeClass('show-first-paragraph');
                animationContainer.addClass('show-last-paragraph');

                // After 1 seconds, add the shown classes
                setTimeout(function () {
                    animationContainer.addClass('left-arrows-shown right-arrows-shown');
                }, 800);
            }, 500);
        }, 9300);

        // After 6300ms animate from right to left
        setTimeout(function () {
            animateFromRightToLeft();
        }, 9000);

    }
    function animateFromRightToLeft() {
        const animationContainer = jQuery('.how-it-works-animation');

        // If there is no animation container, return false
        if (!animationContainer.length) return false;

        // After 5 seconds, remove the shown classes
        setTimeout(function () {
            animationContainer.removeClass('left-arrows-shown right-arrows-shown');

            // After .5s remove the animated classes
            setTimeout(function () {
                animationContainer.removeClass('left-arrows-animated-reverse right-arrows-animated-reverse');

                // Add the reverse animation classe s

                animationContainer.addClass('left-arrows-animated right-arrows-animated');
                animationContainer.removeClass('show-last-paragraph');
                animationContainer.addClass('show-first-paragraph');

                // After 1 seconds, add the shown classes
                setTimeout(function () {
                    animationContainer.addClass('left-arrows-shown right-arrows-shown');
                }, 800);
            }, 500);
        }, 9300);

        // After 6300ms animate from right to left
        setTimeout(function () {
            animateFromLeftToRight();
        }, 9000);
    }
    animateFromLeftToRight();



    jQuery('#accept-cookies').on('click', function (e) {

        e.preventDefault();

        setCookie('fagura-cookies', 'accepted', 365);

        jQuery('#cookie-banner').addClass('hidden');

        return false;
    });
    jQuery('.header-cta .header-tabs a').on('click', function (e) {

        e.preventDefault();

        const targetIndex = jQuery(this).index();

        jQuery('.header-cta .header-tabs a').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.header-cta .header-tabs-content > div').removeClass('active').addClass('hidden');

        jQuery('.header-cta .header-tabs-content > div').eq(targetIndex).addClass('active').removeClass('hidden');

        return false;

    });
    jQuery('.simple-tabs [role="button"]').on('click', function (e) {

        e.preventDefault();
        const clickedTarget = jQuery(this).attr('data-target');

        jQuery('.simple-tabs [role="button"]').removeClass('active');

        jQuery(this).addClass('active');

        jQuery('.simple-tabs-content > div').removeClass('active').addClass('hidden');

        jQuery('.simple-tabs-content > div#' + clickedTarget).addClass('active').removeClass('hidden');

        return false;

    });

    function runAutoplayForHeaderTabs() {

        // Check if tabs exist
        if (!document.querySelector('.header-cta .header-tabs a')) {
            return;
        }

        // Get all the tab links and content divs
        var tabLinks = document.querySelectorAll('.header-cta .header-tabs a');
        var tabContents = document.querySelectorAll('.header-tabs-content > div');

        // Set the index for the current active tab
        var currentIndex = 0;

        // Function to show the tab at the specified index
        function showTab(index) {
            // Hide all tabs
            for (var i = 0; i < tabContents.length; i++) {
                tabContents[i].style.display = 'none';
            }

            // Show the tab at the given index
            tabContents[index].style.display = 'block';

            // Remove the hidden class from the tab
            tabContents[index].classList.remove('hidden');

            // Remove the active class from the tab links
            for (var i = 0; i < tabLinks.length; i++) {
                tabLinks[i].classList.remove('active');
            }

            // Add the active class to the tab link
            tabLinks[index].classList.add('active');
        }

        // Function to handle the automatic tab switching
        function autoPlay() {
            // Show the next tab
            currentIndex = (currentIndex + 1) % tabLinks.length;
            showTab(currentIndex);
        }

        // Set up the initial tab and content display
        showTab(currentIndex);

        // Set up the interval for automatic tab switching
        var intervalId = setInterval(autoPlay, 6000);

        // Stop the interval when the user interacts with the tabs
        tabLinks.forEach(function (tab, index) {
            tab.addEventListener('click', function (event) {
                event.preventDefault();
                clearInterval(intervalId);

                // Update the current index and show the clicked tab
                currentIndex = index;
                showTab(currentIndex);

                // Restart the autoplay after a click
                intervalId = setInterval(autoPlay, 6000);
            });
        });
    }

    runAutoplayForHeaderTabs();



    function initCountdownTimer() {
        const countdown = document.getElementById("countdown-timer");
        if (!countdown) return;

        (function () {
            const second = 1000,
                minute = second * 60,
                hour = minute * 60,
                day = hour * 24;

            let today = new Date();
            today.setUTCHours(today.getUTCHours() + 3); // Set the time to GMT+2

            //I'm adding this section so I don't have to keep updating this pen every year :-)
            //remove this if you don't need it
            let dd = String(today.getDate()).padStart(2, "0"),
                mm = String(today.getMonth() + 1).padStart(2, "0"),
                yyyy = today.getUTCFullYear(),
                nextYear = yyyy,
                dayMonth = "11/15/",
                birthday = dayMonth + yyyy;

            today = mm + "/" + dd + "/" + yyyy;
            if (today > birthday) {
                birthday = dayMonth + nextYear;
            }
            //end

            const countDown = new Date(birthday).getTime(),
                x = setInterval(function () {

                    const now = new Date().getTime(),
                        distance = countDown - now;

                    document.getElementById("countdown-days").innerText = Math.floor(distance / (day)),
                        document.getElementById("countdown-hours").innerText = Math.floor((distance % (day)) / (hour)),
                        document.getElementById("countdown-minutes").innerText = Math.floor((distance % (hour)) / (minute)),
                        document.getElementById("countdown-seconds").innerText = Math.floor((distance % (minute)) / second);

                    //do something later when date is reached
                    if (distance < 0) {
                        // Hello!
                        document.getElementById("countdown-days").innerText = 0,
                            document.getElementById("countdown-hours").innerText = 0,
                            document.getElementById("countdown-minutes").innerText = 0,
                            document.getElementById("countdown-seconds").innerText = 0;
                        clearInterval(x);
                    }
                    //seconds
                }, 0);
        }());
    }
    initCountdownTimer();

    function paymentGraphDetails(rate, amount, period) {
        jQuery.get('https://api.app.fagura.com/api/public/calculate-payment-graph', { rate, amount, period }).done(
            function (data) {

                var paymentGraph = data.paymentGraph;

                // console.log({ data })

                // Get the total paid sum
                var totalPaid = 0;
                data.paymentGraph.forEach(function (item) {
                    totalPaid += item.monthlyAmount;
                });

                // Set the credit details data
                jQuery('#credit-interest').text(parseFloat(data.rate).toFixed(2) + '%');
                jQuery('#credit-dae').text(parseFloat(data.dae).toFixed(2) + '%');
                jQuery('#credit-period').text(data.period + ' luni');
                jQuery('#credit-sum').text('€' + data.amount);
                jQuery('#credit-you-get').text('€' + data.amount);
                jQuery('#credit-you-pay').text('€' + totalPaid.toFixed(2));

                jQuery('#credit-details-table tbody').html('');

                jQuery(data.paymentGraph).each(function (index, item) {
                    jQuery('#credit-details-table tbody').append(`
                        <tr>
                            <td>${index + 1}</td>
                            <td>${item.date}</td>
                            <td>${item.monthlyAmount.toFixed(2)}</td>
                            <td>${item.credit.toFixed(2)}</td>
                            <td>${item.interest.toFixed(2)}</td>
                            <td>${item.principal.toFixed(2)}</td>
                        </tr>
                    `)
                });

                jQuery('.fagura-modal').removeClass('hidden');

                // monthlyPay = parseFloat(paymentGraph[0].monthlyAmount).toFixed(0);
                // totalPay = parseFloat(parseFloat(paymentGraph[0].monthlyAmount) * period).toFixed(0);
                // $(value).find('.js-calc-mounthly-pay').text(parseFloat(paymentGraph[0].monthlyAmount).toFixed(0) + ' €');
                // $(value).find('.js-calc-total-pay').text(parseFloat(totalPay).toFixed(0) + ' €');
                // $(value).find('.js-calc-percent').text(rate + ' %');

                // // Save the payment data to the row.
                // $(value).attr('data-payment-graph', JSON.stringify(data));
            });
    }


    jQuery('#payment-details-modal').on('click', function (e) {
        e.preventDefault();
        var loan_scope = jQuery('#loan-reason').val();
        var history_type = historyType;
        if (calculatorType && calculatorType === 'business') {
            loan_scope = 'imm';
        }

        var rate = rate_data[history_type][loan_scope];
        const amount = parseInt(jQuery('#calculator-loan-sum-slider').val());
        const period = parseInt(jQuery('#calculator-loan-period-slider').val());

        const data = paymentGraphDetails(rate, amount, period);
    });


    jQuery('.fagura-modal .close-modal svg').on('click', function (e) {
        e.preventDefault();
        jQuery('.fagura-modal').addClass('hidden');
    });

    function calcHeaderImageSize() {
        const headerImage = jQuery('.header-main-image');

        // Check if the header image exists
        if (!headerImage.length) return false;

        // Check if mobile - if so - return false
        if (jQuery(window).outerWidth() < 768) return false;

        // Check if the height of the image exceeds the height of the header
        const imageHeight = headerImage.outerHeight();
        const headerHeight = jQuery('#masthead').outerHeight() - jQuery('.top-row').outerHeight();


        if (imageHeight > headerHeight) {
            headerImage.css({
                'height': (headerHeight - 40) + 'px',
                'width': 'auto'
            });
        } else {
            headerImage.removeAttr('style');
        }

        if (!headerImage.hasClass('loaded')) {
            headerImage.addClass('loaded');
        }
    }

    jQuery(window).on('resize load', function () {
        calcHeaderImageSize();
    });



    // let headerTabsInterval = null;

    // // Create an autoplay function for the header tabs to switch every 5 seconds and reset the counter when a user clicks on a tab
    // function headerTabsAutoplay() {
    //     headerTabsInterval = setInterval(function () {
    //         const currentTab = jQuery('.header-cta .header-tabs a.active').index();
    //         const nextTab = currentTab + 1;

    //         if (nextTab > 2) {
    //             jQuery('.header-cta .header-tabs a').eq(0).trigger('click');
    //         } else {
    //             jQuery('.header-cta .header-tabs a').eq(nextTab).trigger('click');
    //         }
    //     }, 5000);

    //     jQuery('.header-cta .header-tabs a').on('click', function () {
    //         clearInterval(headerTabsInterval);
    //         headerTabsInterval = null;
    //         headerTabsAutoplay();
    //     });
    // }

    // headerTabsAutoplay();
})

function rangeInputSlider(current, target, prefix = '', suffix = '', callback = null) {
    var value = current ? current.value : 0;
    var target = document.getElementById(target);
    target.innerHTML = prefix + value + suffix;

    // If there is a callback function, call it
    if (callback) {
        callback();
    }
}
function loanFormula(sum, rate, term) {
    rate = rate / 100;
    return sum * ((rate / 12) * Math.pow(1 + rate / 12, term)) / (Math.pow(1 + rate / 12, term) - 1);
}
function saveMoneyFormula(sum, rate, term) {
    rate = rate / 100;
    var rate2 = 55 / 100;
    return (((rate2 / 12) * Math.pow(1 + rate2 / 12, term)) / (Math.pow(1 + rate2 / 12, term) - 1) * sum * term - sum) - (((rate / 12) * Math.pow(1 + rate / 12, term)) / (Math.pow(1 + rate / 12, term) - 1) * sum * term - sum + sum * 0.03);
}

function calcPersonalLoan() {

    // Get the values from the form
    var sum = document.getElementById('calculator-loan-sum-slider').value;
    var loan_scope = document.getElementById('loan-reason').value;
    var history_type = document.getElementById('history-type').value || historyType;
    if (calculatorType && calculatorType === 'business') {
        loan_scope = 'imm';
    }
    var rate = rate_data[history_type][loan_scope];
    var term = document.getElementById('calculator-loan-period-slider').value;

    // Calculate the monthly payment
    var monthly_payment = loanFormula(sum, rate, term);

    // Display the monthly payment in the .monthly-rate-result element
    document.getElementsByClassName('monthly-rate-result')[0].innerHTML = monthly_payment.toFixed(2) + ' €';

    // Calculate the saved money and display it
    var saved_money = saveMoneyFormula(sum, rate, term);
    document.getElementsByClassName('saved-money-result')[0].innerHTML = saved_money.toFixed(2) + ' €';

    // Calculate the total payment and display it
    var total_payment = monthly_payment * term;
    document.getElementsByClassName('total-payment-result')[0].innerHTML = total_payment.toFixed(2) + ' €';

    // Calculate the total interest and display it
    document.getElementsByClassName('interest-rate-result')[0].innerHTML = rate.toFixed(2) + '%';
}



/**
 * 
 * @param {string} key The key of the parameter to be inserted
 * @param {value} value The value of the parameter to be inserted
 */
const insertParam = (key, value) => {

    key = encodeURIComponent(key);
    value = encodeURIComponent(value);


    let kvp = window.location.search.substr(1).split('&');
    if (kvp[0] === '') {
        const path = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + key + '=' + value;
        window.history.pushState({ path: path }, '', path);

    } else {
        var i = kvp.length;
        let x;
        while (i--) {
            x = kvp[i].split('=');
            if (x[0] === key) {
                x[1] = value;
                if (value != '') {
                    kvp[i] = x.join('=');
                } else {
                    kvp[i] = null;
                }
                break;
            }
        }
        if (i < 0) {
            // console.log(kvp.length);
            // console.log(kvp[kvp.length])
            if (!kvp[kvp.length]) {
                kvp[kvp.length] = kvp && !kvp[kvp.length] ? [key, value].join('=') : '';
            }
            if (value) {

            } else {
                if (kvp[kvp.length]) {
                    kvp[kvp.length].splice(key, 1);
                }
            }
        }


        kvp = kvp.filter(item => {
            return item !== null;
        })


        const refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + kvp.join('&');
        window.history.pushState({ path: refresh }, '', refresh);
    }
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

// Functions to store and set cookies
function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 1 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires;
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for (var i = 0; i < ca.length; i++) {

        var c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1, c.length);
        }

        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length);
        }

    }

    return null;
}

var rate_data = {
    "excelent": {
        "wedding": 7.9,
        "credit-card": 7.9,
        "car": 8.9,
        "big-procurement": 8.9,
        "household": 8.9,
        "loan-refinancing": 8.9,
        "holliday": 8.9,
        "other": 9.9,
        "medical": 9.9,
        "business": 12.9,
        "imm": 6.5,
    },
    "good": {
        "wedding": 12.9,
        "credit-card": 12.9,
        "car": 12.9,
        "big-procurement": 12.9,
        "household": 12.9,
        "loan-refinancing": 12.9,
        "holliday": 13.9,
        "other": 13.9,
        "medical": 14.9,
        "business": 16.9,
        "imm": 14,
    },
    "bad": {
        "wedding": 31.9,
        "credit-card": 31.9,
        "car": 32.9,
        "big-procurement": 32.9,
        "household": 32.9,
        "loan-refinancing": 32.9,
        "holliday": 32.9,
        "other": 33.9,
        "medical": 33.9,
        "business": 35.9,
        "imm": 28,
    },
    "not-known": {
        "wedding": 13.9,
        "credit-card": 14.9,
        "car": 14.9,
        "big-procurement": 14.9,
        "household": 14.9,
        "loan-refinancing": 14.9,
        "holliday": 15.9,
        "other": 15.9,
        "medical": 16.9,
        "business": 17.9,
        "imm": 17,
    }
};

var calculatorType = 'personal';
var historyType = 'excelent';

